import React, { ReactElement } from 'react';
import Card from '../../../components/card/card.component';
import Widget from '../../../components/widget/widget.component';
import FlexContainer from '../../../components/flex-container/flex-container.component';
import FilteredText from '../../../components/filtered-text/filtered-text.component';
import FileLink from '../../../components/file-link/file-link.component';
import RichTextBlock from '../../../components/rich-text-block/rich-text-block.component';
import FloatingFooterBlock from '../../../components/floating-footer-block/floating-footer-block.component';
import { WIDGET_NAME_ACCOUNT_SUMMARY } from '../../../constants/system/widget-names';

const DashboardWidgetAccountSummary: ReactMemoComponent = React.memo((props: ReactComponentProps): ReactElement => {
  const WIDGET_TITLE_DEFAULT: string = 'Account Summary';

  const {
    accountSummaryData,
    widgetSettings,
  } = props;

  return (
    <Widget
      isScrollable
      isEmpty={!accountSummaryData || (!accountSummaryData.summary && (!accountSummaryData.attachments
        || !accountSummaryData.attachments.length))}
      widgetName={WIDGET_NAME_ACCOUNT_SUMMARY}
      defaultWidgetTitle={WIDGET_TITLE_DEFAULT}
      widgetSettings={widgetSettings}
    >
      <Card isFlat isContainer isFullHeight>
        {
          !!accountSummaryData.summary && (
            <RichTextBlock>
              <FilteredText text={accountSummaryData.summary} />
            </RichTextBlock>
          )
        }
        {
          accountSummaryData.attachments && !!accountSummaryData.attachments.length && (
            <FloatingFooterBlock>
              {
                accountSummaryData.attachments.map((attachmentItem: Attachment): ReactElement => (
                  <FlexContainer isInline key={attachmentItem.id}>
                    <FileLink fileLink={attachmentItem.file} />
                  </FlexContainer>
                ))
              }
            </FloatingFooterBlock>
          )
        }
      </Card>
    </Widget>
  );
});

export default DashboardWidgetAccountSummary;
